// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function SpiritType({ spirit, ...rest }) {
  if (!spirit?.spiritType) return null;
  return (
    <Section title={<Trans comment="Type of spirit">Type</Trans>} {...rest}>
      <Text>{spirit.spiritType}</Text>
    </Section>
  );
}

export const fragment = graphql`
  fragment SpiritType on Spirit {
    spiritType
  }
`;

SpiritType.fragment = gql`
  fragment SpiritType on Spirit {
    spiritType
  }
`;
